"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unflatten = exports.scrollToTop = exports.giftAidAmount = exports.flatten = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _reactScroll = require("react-scroll");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var giftAidAmount = function giftAidAmount(amountValue, giftaidValue) {
  if (amountValue && giftaidValue) {
    return "\xA3".concat((amountValue / 100 * 1.25).toFixed(2));
  }

  if (amountValue && !giftaidValue) {
    return "\xA3".concat((amountValue / 100).toFixed(2));
  }

  return 'Please enter an amount';
}; // https://gist.github.com/penguinboy/762197#gistcomment-2083577


exports.giftAidAmount = giftAidAmount;

var flatten = function flatten(object) {
  return Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2["default"])(function _flatten(child) {
    var _ref;

    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return (_ref = []).concat.apply(_ref, (0, _toConsumableArray2["default"])(Object.keys(child).map(function (key) {
      return (0, _typeof2["default"])(child[key]) === 'object' ? _flatten(child[key], path.concat([key])) : (0, _defineProperty2["default"])({}, path.concat([key]).join('.'), child[key]);
    })));
  }(object))));
}; // https://medium.com/@romans.bermans/a-few-javascript-es6-one-liners-for-rapid-data-transformation-b8fe32090b59


exports.flatten = flatten;

var unflatten = function unflatten(o) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.';

  /* eslint-disable no-param-reassign, no-return-assign */
  var r = {};

  if (o) {
    Object.keys(o).forEach(function (k) {
      return k.split(d).reduce(function (p, c, i, a) {
        return i === a.length - 1 ? p[c] = o[k] : p[c] = p[c] ? p[c] : {};
      }, r);
    });
  }

  return r;
  /* eslint-enable no-param-reassign, no-return-assign */
};

exports.unflatten = unflatten;

var scrollToTop = function scrollToTop() {
  var options = {
    delay: 1,
    duration: 1
  };

  _reactScroll.animateScroll.scrollToTop(options);
};

exports.scrollToTop = scrollToTop;